module.exports = __webpack_public_path__ + "static/media/team-ivan.66c2ec9c.png";